import React from "react";
import { Helmet } from "react-helmet";
import withNotifications from "../../../../../hocs/withNotifications";
import config from "../../../../../config";

function getTitle(title, newNotificationsUnreadCount) {
  let newTitle = "";

  const finalUnreadCount = newNotificationsUnreadCount || 0;

  if (finalUnreadCount) {
    newTitle += `(${finalUnreadCount}) `;
  }

  newTitle += `${title} - ${config.title}`;

  return newTitle;
}

const PageTitle = ({ title, newNotificationsUnreadCount }) => (
  <Helmet title={getTitle(title, newNotificationsUnreadCount)} />
);

PageTitle.propTypes = {};

export default withNotifications(PageTitle);
